import type { Country } from '../country';
import { genericPhoneNumber } from '@tectonics/commons/customer-form/generic-phone-number';
import { validateIndonesianPhoneNumber } from '@tectonics/prs/indonesia/validation/indonesian-phone';

const INDONESIA_PHONE_MASK = [
  /\d/, /\d/, /\d/, /\d/, /\d/,
  /\d/, /\d/, /\d/, /\d/, /\d/,
  /\d/, /\d/, /\d/, /\d/, /\d/,
  /\d/, /\d/, /\d/, /\d/, /\d/,
];

const INDONESIA: Country = {
  code: 'id',
  customerForm: {
    phoneNumber: {
      ...genericPhoneNumber,
      mask: INDONESIA_PHONE_MASK,
      inputFieldName: 'indonesianPhoneNumber',
      validationFunction: validateIndonesianPhoneNumber,
    },
  },
};

export default INDONESIA;
